import React from 'react';
import { useRecordContext } from 'react-admin';

import AcceptApplication from "./acceptApplicationDialog";
import Card from "@mui/material/Card";
// import DateField from '@mui/material/';


const ApplicationActions = ({ source, record: recordProp }) => {
  const recordFromContext = useRecordContext();
  const record = recordProp || recordFromContext;
if(record.status ==='Accepted')
{
    return null
}

    return (
        <Card style={{marginTop:50}}>
            {/*Status*/}
            {/*<RadioGroup*/}
            {/*    className="select-all"*/}
            {/*    color="primary"*/}

            {/*/>*/}
            <AcceptApplication record={record}/>


        </Card>
    );
};

export default ApplicationActions;
